import { Component, OnInit } from '@angular/core';
import { TableService } from '../../core/services/table.service';
import { TableColumn } from '../../core/models/table.model';
import { Breakpoint } from '../../core/services/responsive.service';
import { RowItem } from '../../core/models/item.model';
import { DownloadService, Download } from '../../core/services/download.service';

@Component({
    selector: 'downloads',
    templateUrl: './downloads.component.html',
    styleUrls: ['./downloads.component.less'],
})
export class DownloadsComponent implements OnInit {
    public downloads: Download[] = [];

    constructor(public tableService: TableService, public downloadService: DownloadService) {}

    async ngOnInit(): Promise<void> {
        this.downloads = await this.downloadService.getDownloads();        
        this.tableService.register(
            {
                paginator: false,
                breakpoint: { column: [Breakpoint.MD], row: [Breakpoint.MD] },
            },
            this.mapColumns.bind(this),
            this.mapDownloadsToTable.bind(this),
            this.downloads
        );
    }

    /**
     * Map columns for the table
     *
     * @author    Arjan Koemans <arjan@safira.nl>
     */
    private mapColumns(): TableColumn[] {
        return [
            {
                item: { type: 'text', text: 'Titel' },
                sortOn: 'title',
                width: 75,
                breakpoint: {
                    breakpoint: Breakpoint.MD,
                    widthUntil: 40,
                },
            },
            {
                item: { type: 'text', text: 'Downloaden' },
                position: 'center',
                width: 25,
                breakpoint: {
                    breakpoint: Breakpoint.MD,
                    state: 'after',
                },
            },
        ];
    }

    /**
     * Map invoices to table format
     *
     * @author    Arjan Koemans <arjan@safira.nl>
     */
    private mapDownloadsToTable(download: { title: string; href: string }): RowItem {
        return {
            type: 'row',
            expandable: {
                breakpoint: Breakpoint.MD,
                colspan: 2,
                gap: 10,
                closedHeight: 16.8,
                openHeight: 83.6,
            },
            items: [
                {
                    type: 'text',
                    text: download.title,
                    expansion: 'hidden',
                },
                {
                    type: 'group',
                    position: 'center',
                    expansion: 'expandable',
                    items: [
                        {
                            type: 'text',
                            icon: 'cloud-arrow-down',
                            iconHover: true,
                            iconBorder: true,
                            action: {
                                type: 'anchor',
                                route: '/api/media/files/' + download.href,
                                target: 'blank',
                                download: true,
                            },
                            title: 'Downloaden',
                        },
                    ],
                },
            ],
        };
    }
}
